import { Injectable } from '@angular/core';

import { CanActivate, Router } from '@angular/router';

import { Auth } from '../../services/auth/auth-service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: Auth,
    private router: Router,
  ) {}

  canActivate(): boolean {
    // =====================================
    // CHECK LOGIN
    // =====================================

    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/login']);

      return false;
    }

    // =====================================
    // VALID ROLES ONLY
    // =====================================

    const role = this.authService.getRole();

     

    return true;
  }
}